import { useState, useEffect } from "react";
import { Camera } from "lucide-react";
import { getLeadPhotos, photoFileUrl } from "../services/uploadService";
import { PhotoViewer } from "./wizard/PhotoViewer";

export const LeadPhotoGallery = ({ leadId, token, compact = false }) => {
  const [photos, setPhotos] = useState([]);
  const [viewerIndex, setViewerIndex] = useState(null);

  useEffect(() => {
    if (!leadId || !token) return;
    let cancelled = false;
    getLeadPhotos(leadId, token)
      .then((data) => { if (!cancelled) setPhotos(data || []); })
      .catch(() => { if (!cancelled) setPhotos([]); });
    return () => { cancelled = true; };
  }, [leadId, token]);

  if (!photos.length) return null;

  const viewerPhotos = photos.map((p) => ({
    src: photoFileUrl(p.photo_id, { token }),
    caption: p.caption,
    name: p.original_filename,
  }));

  return (
    <div data-testid={`lead-photos-${leadId}`}>
      <p className="text-xs font-medium text-[#1F2933]/60 mb-2 flex items-center gap-1">
        <Camera className="w-3.5 h-3.5" /> {photos.length} project photo{photos.length !== 1 ? "s" : ""}
      </p>
      <div className="flex flex-wrap gap-2">
        {photos.map((p, idx) => (
          <button
            key={p.photo_id}
            type="button"
            onClick={() => setViewerIndex(idx)}
            className="relative group"
            data-testid={`lead-photo-thumb-${idx}`}
          >
            <img
              src={viewerPhotos[idx].src}
              alt={p.caption || p.original_filename || "Project photo"}
              className={`${compact ? "w-14 h-14" : "w-20 h-20"} rounded-lg object-cover border border-gray-200 group-hover:opacity-80 transition-opacity`}
              loading="lazy"
            />
          </button>
        ))}
      </div>
      <PhotoViewer
        photos={viewerPhotos}
        index={viewerIndex}
        onClose={() => setViewerIndex(null)}
        onIndexChange={setViewerIndex}
      />
    </div>
  );
};
